export const RESET_TRACLINK_STORE = '[TracLink] Reset Store';

export const GET_TOUR_EVENTS = '[TourEvent] Get Tour Events';
export const GET_TOUR_EVENTS_SUCCESS = '[TourEvent] Get Tour Events Success';
export const GET_TOUR_EVENTS_ERROR = '[TourEvent] Get Tour Events Error';

export const CREATE_EVENT_DRAFT = '[TourEvent] Create Tour Event Draft';
export const RESET_EVENT_DRAFTS = '[TourEvent] Reset Tour Event Drafts';

export const ADD_TOUR_EVENT = '[TourEvent] Add Tour Event';
export const ADD_TOUR_EVENT_SUCCESS = '[TourEvent] Add Tour Event Success';
export const ADD_TOUR_EVENT_ERROR = '[TourEvent] Add Tour Event Error';

export const UPDATE_TOUR_EVENT = '[TourEvent] Update Tour Event';
export const UPDATE_TOUR_EVENT_SUCCESS =
  '[TourEvent] Update Tour Event Success';
export const UPDATE_TOUR_EVENT_ERROR = '[TourEvent] Update Tour Event Error';

export const DELETE_TOUR_EVENT = '[TourEvent] Delete Tour Event';
export const DELETE_TOUR_EVENT_SUCCESS =
  '[TourEvent] Delete Tour Event Success';
export const DELETE_TOUR_EVENT_ERROR = '[TourEvent] Delete Tour Event Error';
